// Utility to get the base path for routing and redirects
export function getRouterBase() {
  const base = import.meta.env.VITE_API_BASE_URL;
  if (!base) return '/';
  if (base.startsWith('http')) return '/';
  let b = base.startsWith('/') ? base : '/' + base;
  b = b.endsWith('/') ? b.slice(0, -1) : b;
  return b;
} 